import {
  Combobox,
  ComboboxContent,
  ComboboxEmpty,
  ComboboxInput,
  ComboboxItem,
  ComboboxList,
} from '@/components/ui/combobox';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';

export type SearchableSelectOption = {
  value: string;
  label: string;
};

type SearchableSelectProps = {
  id?: string;
  label?: string;
  options: SearchableSelectOption[];
  value: SearchableSelectOption | null;
  onChange: (next: SearchableSelectOption | null) => void;
  placeholder?: string;
  disabled?: boolean;
  clearable?: boolean;
  invalid?: boolean;
  contentClassName?: string;
  itemClassName?: string;
  positionerClassName?: string;
  'aria-label'?: string;
};

export function SearchableSelect({
  id,
  label,
  options,
  value,
  onChange,
  placeholder,
  disabled,
  clearable = false,
  invalid,
  contentClassName,
  itemClassName,
  positionerClassName,
  'aria-label': ariaLabel,
}: SearchableSelectProps) {
  return (
    <div className="tw:space-y-2">
      {label ? <Label htmlFor={id}>{label}</Label> : null}
      <Combobox
        items={options}
        value={value}
        onValueChange={(next) =>
          onChange((next as SearchableSelectOption | null) ?? null)
        }
        itemToStringValue={(item) => (item as SearchableSelectOption).label}
        disabled={disabled}
      >
        <ComboboxInput
          id={id}
          placeholder={placeholder}
          disabled={disabled}
          showClear={clearable}
          aria-invalid={invalid || undefined}
          aria-label={ariaLabel}
          className="tw:w-full"
        />
        <ComboboxContent
          className={cn('dark', contentClassName)}
          positionerClassName={positionerClassName}
        >
          <ComboboxEmpty>No matches</ComboboxEmpty>
          <ComboboxList>
            {(item: SearchableSelectOption) => (
              <ComboboxItem
                key={item.value}
                value={item}
                className={itemClassName}
              >
                <span className="tw:min-w-0 tw:flex-1 tw:whitespace-normal tw:break-words">
                  {item.label}
                </span>
              </ComboboxItem>
            )}
          </ComboboxList>
        </ComboboxContent>
      </Combobox>
    </div>
  );
}
